import { graphql } from 'gql';

export const bimWorkOrderChangeOtherSelectionListGql = graphql(`
    query bimWorkOrderChangeOtherSelectionList(
        $workOrderChangeId: Long!
        $constructionTypeId: Int!
        $where: BimWorkOrderChangeOtherSelectionDataFilterInput
    ) {
        bimWorkOrderChangeOtherSelectionList(
            workOrderChangeId: $workOrderChangeId
            constructionTypeId: $constructionTypeId
            where: $where
        ) {
            items {
                contractOtherCostId
                name
                calculatingType
                calculatingTypeValue
                chapter
                section
                status
                costLimit
                totalRemainderCost
                deviation
            }
        }
    }
`);

export const bimWorkOrderChangeAddOtherGql = graphql(`
    mutation bimAddWorkOrderChangeOthers($input: BimWorkOrderChangeOtherInput!) {
        bimAddWorkOrderChangeOthers(input: $input) {
            data {
                itemIds
                workOrderChangeId
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);
